import io from "socket.io-client";
import api from "../services/api";


class SocketWorker {
  constructor(companyId , userId) {
    if (!SocketWorker.instance) {
      this.companyId = companyId
      this.userId = userId
      this.token = this.getToken()
      this.socket = null;
      this.configureSocket();
      this.eventListeners = {}; // Armazena os ouvintes de eventos registrados
      SocketWorker.instance = this;

    } 

    return SocketWorker.instance;
  }

  normalizeToken(tokenValue) {
    if (tokenValue == null) return undefined;

    let token = String(tokenValue).trim();
    if (!token) return undefined;

    // Strip surrounding quotes (common when token is stored JSON-stringified)
    if (
      (token.startsWith("\"") && token.endsWith("\"")) ||
      (token.startsWith("'") && token.endsWith("'"))
    ) {
      token = token.slice(1, -1).trim();
    }

    // Remove Bearer prefix to sanitize inner token first
    if (/^bearer\s+/i.test(token)) {
      token = token.replace(/^bearer\s+/i, "").trim();
    }

    // Strip quotes again after removing prefix, e.g. Bearer "JWT"
    if (
      (token.startsWith("\"") && token.endsWith("\"")) ||
      (token.startsWith("'") && token.endsWith("'"))
    ) {
      token = token.slice(1, -1).trim();
    }

    if (!token) return undefined;

    // Ensure Bearer format (server expects token query param in this format today)
    return `Bearer ${token}`;
  }

  getToken() {
    const authHeader = api?.defaults?.headers?.Authorization;
    if (typeof authHeader === "string" && authHeader.trim().length > 0) {
      return this.normalizeToken(authHeader);
    }

    try {
      const token = localStorage.getItem("token");
      return this.normalizeToken(token);
    } catch (e) {
      return undefined;
    }
  }

  configureSocket() {
    this.token = this.getToken();
    this.socket = io(`${process.env.REACT_APP_BACKEND_URL}/${this?.companyId}` , {
      autoConnect: true,
      reconnection: true,
      reconnectionDelay: 1000,
      reconnectionAttempts: Infinity,
      // transports: ["websocket", "polling", "flashsocket"],
      // pingTimeout: 18000,
      // pingInterval: 18000,
      query: {
        userId: this.userId,
        ...(this.token ? { token: this.token } : {})
      }
    });

    this.socket.on("connect", () => {
      if (process.env.NODE_ENV !== "production") {
        console.log("Conectado ao servidor Socket.IO");
      }
    });

    this.socket.on("connect_error", (err) => {
      // Avoid infinite reconnect storms when backend rejects the handshake (e.g. 400 due to bad token)
      if (process.env.NODE_ENV !== "production") {
        // eslint-disable-next-line no-console
        console.warn("Socket.IO connect_error:", err?.message || err);
      }

      const status =
        err?.description?.status ||
        err?.data?.status ||
        err?.data?.code ||
        err?.status;

      if (status === 400) {
        try {
          this.socket.io.opts.reconnection = false;
        } catch (e) {}
        try {
          this.socket.disconnect();
        } catch (e) {}
      }
    });

    this.socket.on("disconnect", () => {
      if (process.env.NODE_ENV !== "production") {
        console.log("Desconectado do servidor Socket.IO");
      }
      this.reconnectAfterDelay();
    });
  }

  // Adiciona um ouvinte de eventos
  on(event, callback) {

    this.connect();
    this.socket.on(event, callback);

    // Armazena o ouvinte no objeto de ouvintes
    if (!this.eventListeners[event]) {
      this.eventListeners[event] = [];
    }
    this.eventListeners[event].push(callback);
  }

  // Emite um evento
  emit(event, data) {
    this.connect();
    this.socket.emit(event, data);
  }

  // Desconecta um ou mais ouvintes de eventos
  off(event, callback) {
    // console.log(event, callback)
    this.connect();
    if (this.eventListeners[event]) {
      // console.log("Desconectando do servidor Socket.IO:", event, callback);
      if (callback) {
        // Desconecta um ouvinte específico
        this.socket.off(event, callback);
        this.eventListeners[event] = this.eventListeners[event].filter(cb => cb !== callback);
      } else {
        // console.log("DELETOU EVENTOS DO SOCKET:", this.eventListeners[event]);

        // Desconecta todos os ouvintes do evento
        this.eventListeners[event].forEach(cb => this.socket.off(event, cb));
        delete this.eventListeners[event];
      }
      // console.log("EVENTOS DO SOCKET:", this.eventListeners);
    }
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null
      this.instance = null
      if (process.env.NODE_ENV !== "production") {
        console.log("Socket desconectado manualmente");
      }
    }
  }

  reconnectAfterDelay() {
    setTimeout(() => {
      if (!this.socket || !this.socket.connected) {
        if (process.env.NODE_ENV !== "production") {
          console.log("Tentando reconectar após desconexão");
        }
        this.connect();
      }
    }, 1000);
  }

  // Garante que o socket esteja conectado
  connect() {
    if (!this.socket) {
      this.configureSocket();
    }
  }

  forceReconnect() {

  }
}

// const instance = (companyId, userId) => new SocketWorker(companyId,userId);
const instance = (companyId, userId) => new SocketWorker(companyId, userId);

export default instance;
